import type { FaireProductEntity } from "../../entity_types/product";

export const p_jma64737gr: FaireProductEntity = {
  token: "p_jma64737gr",
  type: "product",
  name: "Calm House — Woodwick Candle (Eucalyptus + Chamomile) 10 oz",
  brandToken: "b_82anes87bj",
  brandName: "By Odiri",
  imageUrl:
    "https://cdn.faire.com/fastly/de4cb96904e1f8f4a11de860856b326f5a9432a99e4aa9c2547ced8288333965.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22afd696f73b95bcf641f8b9f5b31ded32aaec25cfda3049b9fb11e27c0e4c8f.png",
    "https://cdn.faire.com/fastly/810e7903f43d5c7fd702d642720ab6b875652afc61a8e84e4987fee2b6748a56.png",
    "https://cdn.faire.com/fastly/b13680046e30a5277b1769a4573d687ce593703e5bdd9b8eb7df18bef1348aaf.jpeg",
    "https://cdn.faire.com/fastly/c95a9c67ddf0697d6f0786de7dee8c0cd358a2fa80a43fae5bc46ca47c04ce3e.png",
    "https://cdn.faire.com/fastly/8e7870df8cdb511ffc02a75c242778c50ea0ecefc23a28cbaaf14f1c6359aa32.jpeg",
    "https://cdn.faire.com/fastly/5c8e2402fcc584c7a9e20fddf7c30dd952d542f23938bae82ee4bbff05b099d5.jpeg",
  ],
  priceDollars: 15,
  description:
    "Calm House is a breath of fresh air—where crisp eucalyptus, grounding herbs, and soft woods create a sanctuary of peace and clarity.\n\nInspired by quiet mornings and open windows, this restorative blend opens with cooling eucalyptus and calming chamomile before unfolding into an herbal heart of rosemary and sage. Earthy cedar and fir settle the fragrance with a gentle, woodsy warmth, creating an atmosphere that feels both refreshing and grounding.\n\nCrafted to transform everyday moments into ritual, Calm House invites stillness, renewal, and the simple luxury of a clear mind and calm space.\n\nFragrance Notes\nEucalyptus · Chamomile · Rosemary · Sage\n\nFeel the Mood\nTranquility · Clean Air\n\nDetails\n• 10 oz candle\n• Hand-poured\n• Approx. burn time: 45–50 hours\n• Coconut Wax Blend\n• Wooden Wick",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:53.468Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
